import React, { Component } from 'react'
import CacheManager from '../../../cache/CacheManager'
import CacheKeys from '../../../cache/CacheKeys'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import AccountLoanListUI from './AccountLoanListUI'

class AccountLoanListSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filteredLoanList: [],
      copyToClipboardText: null,
      searchFilter: '',
    }
  }

  render() {
    return (
      <AccountLoanListUI
        context={this.props.context}
        loanList={this.props.loanList}
        account={this.props.account}
        onRowClick={this.onRowClick}
        onRefreshClick={this.props.onRefreshClick}
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        //
        createLoanMode={this.props.createLoanMode}
        onCreateLoanClick={this.props.onCreateLoanClick}
        onCancelCreateLoan={this.props.onCancelCreateLoan}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    let filtersStr = sessionStorage.getItem(CacheKeys.LoansFilter())
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.applyFilters(this.props.loanList, filters.searchFilter ? filters.searchFilter : '')
  }

  onRowClick = (event) => {
    let loanId = event.currentTarget.getAttribute('data-row-id')
    window.location.href = `/su/loans/${loanId}`
  }

  onCopyToClipboard = (text, result) => {
    this.setState({ copyToClipboardText: text })
    setTimeout(() => {
      this.setState({ copyToClipboardText: null })
    }, 3000)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.props.loanList, searchFilter)
  }

  applyFilters(loanList, searchFilter, errorList) {
    let filteredList = loanList
    if (searchFilter) {
      searchFilter = searchFilter.toLocaleLowerCase()
      filteredList = filteredList.filter(loan =>
        loan.accountName.toLocaleLowerCase().includes(searchFilter) ||
        loan.status.includes(searchFilter) ||
        loan.subStatus && loan.subStatus.includes(searchFilter) ||
        loan.assignedUserName && loan.assignedUserName.toLocaleLowerCase().includes(searchFilter)
      )
    }

    this.setState({
      filteredLoanList: filteredList,
      searchFilter: searchFilter,
    })

    let filters = { searchFilter: searchFilter }
    sessionStorage.setItem(CacheKeys.LoansFilter(), JSON.stringify(filters))
  }
}

export default AccountLoanListSF
